// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAMtn4TcUKEvyHsYhTMvlhW-4T8vPsfL4U",
    authDomain: "dtpc-edakkal-caves.firebaseapp.com",
    projectId: "dtpc-edakkal-caves",
    storageBucket: "dtpc-edakkal-caves.appspot.com",
    messagingSenderId: "270609477317",
    appId: "1:270609477317:web:a7110269e762794b670aac",
    measurementId: "G-ENZNWJNZV9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);
export { db, collection, getDocs, analytics };